import { useState } from "react";
import ParticleBackground from "../components/ParticleBackground";
import { ArrowRight, Globe2, School,  MonitorSmartphone } from "lucide-react";

const projects = {
  mobile: [
    {
      title: "CakesNationZim",
      type: "Mobile Application",
      image: "/projects/cakes.jpeg",
      description: "A modern ordering platform for browsing and placing orders.",
      icon: <MonitorSmartphone size={28} />,
      link: "https://cakesnationzim.vercel.app/",
    },
    {
      title: "Shalom Schools Portal",
      type: "Mobile Application",
      image: "/projects/shalom.jpeg",
      description:
        "A full-stack school portal for managing students, teachers, reports, fees, dashboards and academic performance.",
      icon: <School size={28} />,
      link: "https://shalomschoolsmurewa.eiffeltech.co.zw",
    },
    {
      title: "AI-Powered EHR System",
      type: "Healthcare System",
      image: "/projects/EHR.jpeg",
      description:
        "A secure electronic health records platform with AI health insights, appointments, emergency support and role-based access.",
      icon: <Globe2 size={28} />,
      link: "#",
    },
  ],

  websites: [
    {
      title: "Shalom Schools Website",
      type: "Website",
      image: "/projects/shalomwebsite.jpeg",
      description: "A modern responsive school website.",
      icon: <School size={28} />,
      link: "https://shalomgroupofschools.eiffeltech.co.zw/",
    },
    {
      title: "Personal Website",
      type: "Website",
      image: "/projects/tino.jpeg",
      description: "A personal portfolio website.",
      icon: <Globe2 size={28} />,
      link: "https://tinotendachigumira.eiffeltech.co.zw/",
    },
    {
      title: "Proxima Tyres",
      type: "Website",
      image: "/projects/proxima.jpeg",
      description: "A professional tyre and automotive services website.",
      icon: <Globe2 size={28} />,
      link: "https://www.proximatyres.com/",
    },
     {
      title: "Rejoice Music",
      type: "Website",
      image: "/projects/Rejo.jpeg",
      description: "Rejoice Music is a gospel music platform inspiring lives through uplifting music, ministry, and community.",
      icon: <Globe2 size={28} />,
      link: "https://rejoice-music-web.vercel.app/",
    },
  ],
};

const tabs = [
  { id: "mobile", label: "Mobile Applications" },
  { id: "websites", label: "Websites" },
];

function Projects() {
  const [activeTab, setActiveTab] = useState("mobile");

  return (
    <section className="relative min-h-screen overflow-hidden px-4 pt-28 pb-16 sm:px-6">
      <div className="absolute inset-0 z-0">
        <ParticleBackground />
      </div>

      <div className="relative z-20 mx-auto max-w-7xl">
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-cyan-400 sm:text-sm">
            Our Work
          </p>

          <h1 className="mt-4 text-3xl font-black sm:text-5xl md:text-6xl lg:text-7xl">
            Projects built to solve real problems
          </h1>

          <p className="mt-5 text-sm text-slate-300 sm:text-lg">
            Eiffeltech builds scalable digital systems for real-world use.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-8 text-sm font-bold sm:text-lg">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={
                activeTab === tab.id
                  ? "border-b-2 border-cyan-400 pb-2 text-cyan-400"
                  : "pb-2 text-slate-300 hover:text-cyan-400"
              }
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {projects[activeTab].map((project) => (
            <ProjectCard key={project.title} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProjectCard({ project }) {
  return (
    <div className="h-full overflow-hidden rounded-2xl border border-cyan-400/20 bg-slate-900/80 backdrop-blur-xl">
      <div className="relative h-44 sm:h-48">
        <img
          src={project.image}
          alt={project.title}
          className="h-full w-full object-cover"
        />

        <div className="absolute inset-0 bg-black/40" />

        <div className="absolute bottom-3 left-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-400 text-black">
            {project.icon}
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-6">
        <p className="mb-2 text-xs font-bold uppercase tracking-wide text-cyan-400">
          {project.type}
        </p>

        <h3 className="text-lg font-bold sm:text-xl">{project.title}</h3>

        <p className="mt-2 text-sm text-slate-300">
          {project.description}
        </p>

        {project.link !== "#" && (
          <a
            href={project.link}
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-cyan-400"
          >
            View Project <ArrowRight size={16} />
          </a>
        )}
      </div>
    </div>
  );
}

export default Projects;
